const PURCHASE_BO_URL = 'https://assimil-bo.mantano.com/purchase/list';

export interface PurchaseSearch {
  email?: string | null;
  ean?: string | null;
  orderId?: string | null;
}

/**
 * Builds a pre-filled search on the purchase back-office.
 *
 * Every field the form expects is sent, empty when unused: the back-office is a
 * Grails app and reads its criteria straight from the query string.
 *
 * About the dates: `_dateFilter` with no matching `dateFilter` is Grails' way of
 * encoding an unchecked checkbox, so no period is applied and the bounds below
 * are only the form's defaults. They are deliberately wide rather than copied
 * from a real search — should the filter ever be applied, a wide range still
 * finds the purchase, whereas a single day would silently return nothing.
 */
export function purchaseBackOfficeUrl({email, ean, orderId}: PurchaseSearch): string {
  const params = new URLSearchParams({
    orderId: orderId ?? '',
    email: email ?? '',
    ean: ean ?? '',
    _dateFilter: '',
    _paidOnly: '',
    start: 'date.struct',
    start_day: '1',
    start_month: '1',
    start_year: '2000',
    end: 'date.struct',
    end_day: '31',
    end_month: '12',
    end_year: '2099',
    max: '100',
  });
  return `${PURCHASE_BO_URL}?${params.toString()}`;
}
